export enum StatusType {
  idle = "idle",
  loading = "loading",
  succeeded = "succeeded",
  errored = "errored",
}
